import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import MobileSuiteBusinessObjectives from '../../mobile/MobileSuiteBusinessObjectives';
import ProductBusinessObjectives from '../business-objectives/ProductBusinessObjectives';
import SuiteBusinessObjectives from '../business-objectives/SuiteBusinessObjectives';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductTileBusinessObjectives = ({
  productLevel,
  isHubspotFree,
  isSuiteProduct,
  apiName
}) => {
  const isMobile = useIsMobile();
  const shouldShowSuiteObjectives = (isHubspotFree || isSuiteProduct) && productLevel && productLevel !== 'BASIC';
  if (shouldShowSuiteObjectives) {
    return isMobile ? /*#__PURE__*/_jsx(MobileSuiteBusinessObjectives, {
      productLevel: productLevel
    }) : /*#__PURE__*/_jsx(SuiteBusinessObjectives, {
      productLevel: productLevel
    });
  }
  return /*#__PURE__*/_jsx(ProductBusinessObjectives, {
    apiName: apiName,
    collapsibleBusinessObjectives: isMobile
  });
};
export default ProductTileBusinessObjectives;